import React from 'react';
import { Card as AntCard, CardProps as AntCardProps } from 'antd';

interface CardComponent extends React.FC<AntCardProps> {
  Meta: typeof AntCard.Meta;
}

const Card: CardComponent = ({ title, extra, children, ...restProps }) => (
  <AntCard title={title} extra={extra} {...restProps}>
    {children}
  </AntCard>
);

Card.Meta = AntCard.Meta;

export default Card;
